"use client";

import { FC, PropsWithChildren } from "react";
import { TranslationScopes, AssetsDirectory } from "@finbackoffice/enums";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import Img from "components/base/img/Img";
import Translate from "components/base/translate/Translate";
import Button from "components/base/button/Button";
import { Svg } from "components/base/svg/Svg";
import styles from "./policies.module.sass";

type IProps = {
    translationKey: string;
    translationScope: TranslationScopes;
    headingIcon: { width: number; height: number };
    wrapperClassName?: string;
};

const PoliciesCommonContent: FC<IProps & PropsWithChildren> = ({
    translationKey,
    translationScope,
    children,
    headingIcon,
    wrapperClassName,
}) => {
    const { t } = useTranslation();

    const onPrintPress = () => {
        const printStyles = `
        @media print {
            .printContent, .printContent div > section * { visibility: visible; color: black !important;  }
            html body .printContent .svg-sport-icon svg path { fill: black !important }
            .page > header { visibility: hidden }
            .page:last-child { visibility: hidden }
        }
    `;

        if (!document.getElementById("print-styles")) {
            const style = document.createElement("style");
            style.id = "print-styles";
            style.appendChild(document.createTextNode(printStyles));
            document.head.appendChild(style);
        }

        window.print();

        setTimeout(() => {
            if (document.getElementById("print-styles")) {
                document.getElementById("print-styles")?.remove();
            }
        }, 100);
    };

    return (
        <div className={classNames(styles.content, wrapperClassName, "printContent")}>
            <div
                className={styles.header}
                data-testid={`policies-${translationKey.replaceAll("_", "-")}-heading`}>
                <Img
                    source={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/policies-${translationKey.replaceAll("_", "-")}.svg`}
                    alt={t(`pageName_policies_${translationKey}`)}
                    width={headingIcon.width}
                    height={headingIcon.height}
                />
                <h1>
                    <Translate
                        tid={`policies_${translationKey}_heading`}
                        namespace={translationScope}
                    />
                </h1>
                <Button
                    type="button"
                    variant="custom"
                    onClick={onPrintPress}
                    className={styles.print}>
                    <Svg
                        src={`/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.BaseIcons}/print.svg`}
                    />
                </Button>
            </div>
            {children}
        </div>
    );
};

export default PoliciesCommonContent;
